__webpack_require__.p = "https://static.parastorage.com/services/restaurant-menus-showcase-ooi/0219226ace9511c10714c4836c4b8a6983550d3b85f45309820e7695/";